(function() { window.GUID_333d2ce0_426e_406e_b69f_472d088c1e8a = { getGuid: function() { return "333d2ce0-426e-406e-b69f-472d088c1e8a"; } }; })();
var CS;
(function (CS) {
    class CSZoomCanvas {
        constructor(canvas, noDrag) {
            this.Scale = 1;
            this.Freeze = false;
            this.ScaleSpeed = 5;
            this.MouseDragging = false;
            this.IsEmpty = true;
            this.MouseHasNeverMove = true;
            this.MouseWheel = 0;
            this.MouseDown = false;
            this.LoadingContent = false;
            this.AnchorTop = false;
            this.translateAlreadyCalled = false;
            this.TouchDistance = 0;
            this.TouchDragIdentifier = null;
            this.TouchDragPosition = null;
            this.uiDiscovery(canvas);
            if (this.Canvas.length != 0) {
                this.bindEvent(noDrag);
            }
        }
        uiDiscovery(canvas) {
            let me = this;
            this.Canvas = canvas;
            this.CanvasContent = $('.CSZoomCanvasContent', canvas);
            if (this.Canvas.length == 0) {
                return;
            }
            this.CanvasId = this.Canvas[0].id;
            eval('document.' + this.CanvasId + '=me;');
            this.MouseDragging = false;
            this.MouseRealPos = new Point(0.0, 0.0);
            this.MouseClickedPos = new Point(0.0, 0.0);
            this.MouseOnScaleCorrection = new Point(0.0, 0.0);
            this.CanvasStartPos = new Point(this.Canvas.offset().left, this.Canvas.offset().top);
            this.CanvasNewTopLeftPos = new Point(0.0, 0.0);
            this.CanvasLastTopLeftPos = new Point(0.0, 0.0);
            this.ScaleCorrectionPoint = new Point(0.0, 0.0);
        }
        bindEvent(noDrag) {
            let me = this;
            let canvasControl = $('#ControlOf' + this.CanvasId);
            CS.win.resize(function () {
                me.CanvasSize = new Point(me.Canvas.width(), me.Canvas.height());
            });
            if (!IsDefined(typeof (noDrag))) {
                noDrag = false;
            }
            if (noDrag) {
                me.Canvas.css('cursor', 'default');
            }
            else {
                $('.FitToContent', canvasControl).on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    me.FitToContent();
                });
                $('.RefreshContent', canvasControl).on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    me.Canvas.trigger('RefreshContent');
                });
                $('.Plus', canvasControl).on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    me.ScaleUpDown(true, true);
                });
                $('.Minus', canvasControl).on('mousedown', function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    me.ScaleUpDown(false, true);
                });
                var mouseWheelEvents = 'mousewheel.' + this.CanvasId;
                mouseWheelEvents += ' DOMMouseScroll.' + this.CanvasId;
                mouseWheelEvents += ' MozMousePixelScroll.' + this.CanvasId;
                $(this.Canvas).on(mouseWheelEvents, function (e) {
                    let mouseEvent = e.originalEvent;
                    me.HandleWheelEvent(mouseEvent, mouseEvent.wheelDelta > 0 || mouseEvent.detail < 0);
                }).on('mousedown.' + this.CanvasId, function (e) {
                    if (me.IsEmpty) {
                        return;
                    }
                    me.MouseClickedPos = new Point(e.clientX, e.clientY);
                    me.MouseDown = true;
                    let hiddenButton = $('.CSZoomCanvasHiddenText');
                    if (hiddenButton.length > 0) {
                        hiddenButton.focus();
                    }
                }).on('contextmenu', function (e) {
                    e.preventDefault();
                }).on('mouseleave', function (e) {
                    if (me.IsEmpty) {
                        return;
                    }
                    me.MouseDown = false;
                    me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                    me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                    if (Math.abs(e.clientX - me.MouseClickedPos.X) < 2 &&
                        Math.abs(e.clientY - me.MouseClickedPos.Y) < 2) {
                        me.CanvasContentEdge.trigger('CanvasClick', e);
                    }
                    me.MouseDragging = false;
                });
                CS.doc.on('mouseup.' + this.CanvasId, function (e) {
                    if (me.IsEmpty) {
                        return;
                    }
                    me.MouseDown = false;
                    me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                    me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                    if (Math.abs(e.clientX - me.MouseClickedPos.X) < 2 &&
                        Math.abs(e.clientY - me.MouseClickedPos.Y) < 2) {
                        me.CanvasContentEdge.trigger('CanvasClick', e);
                    }
                    me.MouseDragging = false;
                }).on('mousemove.' + this.CanvasId, function (e) {
                    if (me.IsEmpty || me.Freeze) {
                        return;
                    }
                    me.MouseHasNeverMove = false;
                    me.MouseRealPos = new Point(e.clientX, e.clientY);
                    me.MouseOnScaleCorrection = me.GetRelativeMousePos();
                    if (me.MouseDown) {
                        e.preventDefault();
                        me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X + (me.MouseRealPos.X - me.MouseClickedPos.X) / me.Scale;
                        me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y + (me.MouseRealPos.Y - me.MouseClickedPos.Y) / me.Scale;
                        me.Translate();
                        if (!me.MouseDragging) {
                            if (Math.abs(e.clientX - me.MouseClickedPos.X) > 2 || Math.abs(e.clientY - me.MouseClickedPos.Y) > 2) {
                                me.MouseDragging = true;
                                me.CanvasContentEdge.trigger('StartDragging', e);
                            }
                        }
                    }
                });
                let hiddenButton = $('.CSZoomCanvasHiddenText');
                hiddenButton.on('keydown.' + this.CanvasId, function (e) {
                    console.log("Keydown " + e.which + " " + me.Scale);
                    if (me.IsEmpty || me.Freeze) {
                        return;
                    }
                    switch (e.which) {
                        case 37: // left
                            me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                            me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X + 20 / me.Scale;
                            me.Translate();
                            break;
                        case 38: // up
                            me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                            me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y + 20 / me.Scale;
                            me.Translate();
                            break;
                        case 39: // right
                            me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                            me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X - 20 / me.Scale;
                            me.Translate();
                            break;
                        case 40: // down
                            me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                            me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y - 20 / me.Scale;
                            me.Translate();
                            break;
                        case 109: // minus
                        case 189: // minus
                            me.ScaleUpDown(false);
                            break;
                        case 107: // plus
                        case 187: // plus
                            me.ScaleUpDown(true);
                            break;
                        default: return; // exit this handler for other keys
                    }
                    e.preventDefault(); // prevent the default action (scroll / move caret)
                });
                this.Canvas[0].addEventListener('wheel', function (e) {
                    if ( /*!e.ctrlKey ||*/me.IsEmpty) {
                        return;
                    }
                    e.preventDefault();
                    me.HandleWheelEvent(e, e.deltaY < 0);
                }, { passive: false });
                this.Canvas[0].addEventListener('touchstart', function (e) {
                    if (me.IsEmpty || me.Freeze) {
                        return;
                    }
                    if (e.touches.length === 1) {
                        me.TouchDragIdentifier = e.touches[0].identifier;
                        me.TouchDragPosition = new Point(e.touches[0].clientX, e.touches[0].clientY);
                        me.MouseDragging = false;
                    }
                    else if (e.touches.length === 2) {
                        me.TouchDragIdentifier = null;
                        me.TouchDragPosition = null;
                        me.TouchDistance = me.GetTouchDistance(e.touches);
                    }
                }, { passive: true });
                this.Canvas[0].addEventListener('touchmove', function (e) {
                    if (me.IsEmpty || me.Freeze) {
                        return;
                    }
                    if (e.touches.length === 1 && me.TouchDragIdentifier !== null) {
                        let touch = me.GetTouchByIdentifier(e.touches, me.TouchDragIdentifier);
                        if (touch === null) {
                            return;
                        }
                        e.preventDefault();
                        let touchPosition = new Point(touch.clientX, touch.clientY);
                        me.CanvasNewTopLeftPos.X += (touchPosition.X - me.TouchDragPosition.X) / me.Scale;
                        me.CanvasNewTopLeftPos.Y += (touchPosition.Y - me.TouchDragPosition.Y) / me.Scale;
                        me.TouchDragPosition = touchPosition;
                        me.Translate();
                        if (!me.MouseDragging) {
                            me.MouseDragging = true;
                            me.CanvasContentEdge.trigger('StartDragging', e);
                        }
                        return;
                    }
                    if (e.touches.length !== 2) {
                        return;
                    }
                    let touchDistance = me.GetTouchDistance(e.touches);
                    if (Math.abs(touchDistance - me.TouchDistance) < 2) {
                        return;
                    }
                    e.preventDefault();
                    let touchCenter = me.GetTouchCenter(e.touches);
                    me.MouseRealPos = touchCenter;
                    me.MouseOnScaleCorrection = me.GetRelativeMousePos();
                    me.ScaleUpDown(touchDistance > me.TouchDistance);
                    me.MouseLastScalePos = touchCenter;
                    me.TouchDistance = touchDistance;
                    me.CanvasContentEdge.trigger('Zooming', e);
                }, { passive: false });
                this.Canvas[0].addEventListener('touchend', function (e) {
                    if (e.touches.length === 1) {
                        me.TouchDragIdentifier = e.touches[0].identifier;
                        me.TouchDragPosition = new Point(e.touches[0].clientX, e.touches[0].clientY);
                        me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                        me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                        me.MouseDragging = false;
                    }
                    else {
                        me.TouchDragIdentifier = null;
                        me.TouchDragPosition = null;
                        me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                        me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                        me.MouseDragging = false;
                    }
                    if (e.touches.length < 2) {
                        me.TouchDistance = 0;
                    }
                }, { passive: true });
                this.Canvas[0].addEventListener('touchcancel', function () {
                    me.TouchDragIdentifier = null;
                    me.TouchDragPosition = null;
                    me.MouseDragging = false;
                    me.TouchDistance = 0;
                    me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                    me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                }, { passive: true });
            }
            me.UpdateContentSizeValue();
            me.FitToContent();
        }
        LoadNewContent(content, updateOnlyHtml, callback) {
            this.MouseDown = false;
            this.ClearContent.call(this);
            if (updateOnlyHtml) {
                this.CanvasContent[0].innerHTML = content;
                this.UpdateContentSizeValue();
                this.IsEmpty = false;
                if (IsDefined(typeof (callback))) {
                    callback.call(this);
                }
            }
            else {
                this.LoadingContent = true;
                this.CanvasContent[0].innerHTML = content;
                this.UpdateContentSizeValue();
                this.IsEmpty = false;
                this.FitToContent(callback);
            }
        }
        ShowHideContent(hide) {
            if (hide) {
                this.CanvasContent.css('visibility', 'hidden');
            }
            else {
                this.CanvasContent.css('visibility', 'visible');
            }
        }
        Translate(callback) {
            let me = this;
            if (!me.translateAlreadyCalled) {
                setTimeout(function () {
                    var left = me.CanvasNewTopLeftPos.X - me.ScaleCorrectionPoint.X + "em";
                    var top = me.CanvasNewTopLeftPos.Y - me.ScaleCorrectionPoint.Y + "em";
                    var fontsize = me.Scale + "em";
                    me.CanvasContent.css({
                        fontSize: fontsize,
                        left: left,
                        top: top
                    });
                    me.CanvasContentEdge.trigger('Moving', me);
                    me.translateAlreadyCalled = false;
                    if (IsDefined(typeof (callback))) {
                        callback.call(this);
                    }
                }, 40);
            }
            me.translateAlreadyCalled = true;
        }
        HandleWheelEvent(mouseEvent, scaleUp) {
            if (this.IsEmpty) {
                return;
            }
            if (this.MouseHasNeverMove) {
                this.MouseRealPos = new Point(mouseEvent.clientX, mouseEvent.clientY);
                this.MouseOnScaleCorrection = this.GetRelativeMousePos();
            }
            this.ScaleUpDown(scaleUp);
            this.MouseLastScalePos = new Point(mouseEvent.clientX, mouseEvent.clientY);
            this.CanvasContentEdge.trigger('Zooming', mouseEvent);
        }
        GetTouchDistance(touches) {
            let horizontalDistance = touches[0].clientX - touches[1].clientX;
            let verticalDistance = touches[0].clientY - touches[1].clientY;
            return Math.sqrt(horizontalDistance * horizontalDistance + verticalDistance * verticalDistance);
        }
        GetTouchCenter(touches) {
            return new Point((touches[0].clientX + touches[1].clientX) / 2, (touches[0].clientY + touches[1].clientY) / 2);
        }
        GetTouchByIdentifier(touches, identifier) {
            for (let index = 0; index < touches.length; index++) {
                if (touches[index].identifier === identifier) {
                    return touches[index];
                }
            }
            return null;
        }
        UpdateContentSizeValue() {
            this.CanvasSize = new Point(this.Canvas.width(), this.Canvas.height());
            this.CanvasContentEdge = $('.CanvasContentEdge', this.Canvas);
            this.ContentSize = new Point(this.CanvasContentEdge.data('canvascontentwidth'), this.CanvasContentEdge.data('canvascontentheight'));
            let position = this.Canvas.offset();
            this.CanvasStartPos = new Point(position.left, position.top);
            this.CanvasContentEdge.data('context', this);
        }
        CalculCorrectionOfTranslation() {
            let ratio = new Point((this.MouseRealPos.X - this.CanvasStartPos.X) / this.CanvasSize.X, (this.MouseRealPos.Y - this.CanvasStartPos.Y) / this.CanvasSize.Y);
            let diff = new Point(this.MouseOnScaleCorrection.X - this.MouseRealPos.X, this.MouseOnScaleCorrection.Y - this.MouseRealPos.Y);
            this.ScaleCorrectionPoint = new Point(((this.CanvasSize.X - this.CanvasSize.X / this.Scale) * ratio.X) + diff.X, ((this.CanvasSize.Y - this.CanvasSize.Y / this.Scale) * ratio.Y) + diff.Y);
        }
        GetRelativeMousePos() {
            return this.GetRelativePoint(this.MouseRealPos.X, this.MouseRealPos.Y);
        }
        GetRelativePoint(_x, _y) {
            var x = (_x - this.CanvasStartPos.X) / this.Scale + (this.ScaleCorrectionPoint.X + this.CanvasStartPos.X);
            var y = (_y - this.CanvasStartPos.Y) / this.Scale + (this.ScaleCorrectionPoint.Y + this.CanvasStartPos.Y);
            return new Point(x, y);
        }
        FitToContent(callback) {
            if (this.CanvasContentEdge != null && this.CanvasContentEdge.length > 0) {
                var ratioX = this.CanvasSize.X / this.ContentSize.X;
                var ratioY = this.CanvasSize.Y / this.ContentSize.Y;
                if (ratioX < ratioY) {
                    this.Scale = ratioX;
                }
                else {
                    this.Scale = ratioY;
                }
                var corrX = parseFloat((((this.CanvasSize.X - (this.ContentSize.X * this.Scale)) / 2) / this.Scale).toFixed(3));
                var corrY = parseFloat((((this.CanvasSize.Y - (this.ContentSize.Y * this.Scale)) / 2) / this.Scale).toFixed(3));
                this.CanvasNewTopLeftPos.X = corrX;
                this.CanvasNewTopLeftPos.Y = corrY;
                this.CanvasLastTopLeftPos.X = corrX;
                this.CanvasLastTopLeftPos.Y = corrY;
                this.ScaleCorrectionPoint.X = 0;
                this.ScaleCorrectionPoint.Y = 0;
                this.Translate(callback);
            }
        }
        CenterElement(element, callback) {
            if (element != null && element.length > 0) {
                var eleLeft = -(this.CanvasLastTopLeftPos.X - this.ScaleCorrectionPoint.X - (element.offset().left - this.CanvasStartPos.X) / this.Scale);
                var eleTop = -(this.CanvasLastTopLeftPos.Y - this.ScaleCorrectionPoint.Y - (element.offset().top - this.CanvasStartPos.Y) / this.Scale);
                var offsetX = this.CanvasSize.X / 2 / this.Scale - eleLeft - (element.width() / this.Scale / 2);
                var offsetY = this.CanvasSize.Y / 2 / this.Scale - eleTop - (element.height() / this.Scale / 2);
                this.CanvasNewTopLeftPos.X = offsetX;
                this.CanvasNewTopLeftPos.Y = offsetY;
                this.CanvasLastTopLeftPos.X = offsetX;
                this.CanvasLastTopLeftPos.Y = offsetY;
                this.ScaleCorrectionPoint.X = 0;
                this.ScaleCorrectionPoint.Y = 0;
                this.Translate(callback);
            }
        }
        ClearContent() {
            this.CanvasContent.html('');
            this.IsEmpty = true;
            this.MouseHasNeverMove = true;
        }
        ScaleUpDown(up, zoomButton) {
            var me = this;
            if (zoomButton) {
                me.MouseRealPos = new Point(me.CanvasSize.X / 2, me.CanvasSize.Y / 2);
                me.MouseOnScaleCorrection = me.GetRelativeMousePos();
            }
            me.Scale += up ? me.ScaleSpeed : -me.ScaleSpeed;
            if (me.Scale < 1) {
                me.Scale = 1;
            }
            me.CalculCorrectionOfTranslation();
            me.Translate();
        }
        ScaleTo(scale, callback) {
            var me = this;
            me.Scale = scale;
            me.CalculCorrectionOfTranslation();
            me.Translate(callback);
        }
    }
    CS.CSZoomCanvas = CSZoomCanvas;
    class Point {
        constructor(x, y) {
            this.X = x;
            this.Y = y;
        }
    }
})(CS || (CS = {}));
/*
CS.CSZoomCanvas = function (canvas, noDrag) {

    var me = this;

    this.Canvas = canvas;

    this.CanvasContent = $('.CSZoomCanvasContent', canvas);
    if (this.Canvas.length == 0) {
        return;
    }
    this.CanvasId = this.Canvas[0].id;

    eval('document.' + this.CanvasId + '=me;');

    this.ScaleSpeed = 5;
    this.Scale = 1;

    this.MouseDragging = false;
    this.MouseRealPos = new Point(0.0, 0.0);
    this.MouseClickedPos = new Point(0.0, 0.0);
    this.MouseOnScaleCorrection = new Point(0.0, 0.0);
    this.IsEmpty = true;
    this.Freeze = false;
    this.MouseHasNeverMove = true;
    this.MouseWheel = 0;
    this.MouseDown = false;
    this.LoadingContent = false;
    this.CanvasStartPos = new Point(this.Canvas.offset().left, this.Canvas.offset().top);
    this.CanvasNewTopLeftPos = new Point(0.0, 0.0);
    this.CanvasLastTopLeftPos = new Point(0.0, 0.0);
    this.ScaleCorrectionPoint = new Point(0.0, 0.0);
    this.AnchorTop = false;

    //this.Canvas.disableSelection();

    var canvasControl = $('#ControlOf' + this.CanvasId);

    CS.win.resize(function () {
        me.CanvasSize = new Point(me.Canvas.width(), me.Canvas.height());
    });
    if (!IsDefined(typeof (noDrag))) {
        noDrag = false;
    }

    if (noDrag) {
        me.Canvas.css('cursor', 'default');
    } else {
        $('.FitToContent', canvasControl).on('mousedown', function (e) {
            e.stopPropagation();
            e.preventDefault();
            me.FitToContent();
        });
        $('.RefreshContent', canvasControl).on('mousedown', function (e) {
            e.stopPropagation();
            e.preventDefault();

            me.Canvas.trigger('RefreshContent');
        });
        $('.Plus', canvasControl).on('mousedown', function (e) {
            e.stopPropagation();
            e.preventDefault();
            me.ScaleUpDown(true, true);
        });
        $('.Minus', canvasControl).on('mousedown', function (e) {
            e.stopPropagation();
            e.preventDefault();
            me.ScaleUpDown(false, true);

        });
        var mouseWheelEvents = 'mousewheel.' + this.CanvasId;
        mouseWheelEvents += ' DOMMouseScroll.' + this.CanvasId;
        mouseWheelEvents += ' MozMousePixelScroll.' + this.CanvasId;

        $(canvas).on(mouseWheelEvents, function (e) {
            e = e.originalEvent;

            if (me.IsEmpty) {
                return;
            }

            if (me.MouseHasNeverMove) {
                //return;
                me.MouseRealPos = new Point(e.clientX, e.clientY);
                me.MouseOnScaleCorrection = me.GetRelativeMousePos();
            }

            if (e.wheelDelta > 0 || e.detail < 0) {
                me.ScaleUpDown(true);
            }
            else {
                me.ScaleUpDown(false);
            }
            me.MouseLastScalePos = new Point(e.clientX, e.clientY);
            me.CanvasContentEdge.trigger('Zooming', e);
        }).on('mousedown.' + this.CanvasId, function (e) {

            if (me.IsEmpty) {
                return;
            }

            me.MouseClickedPos = new Point(e.clientX, e.clientY);
            me.MouseDown = true;

            var hiddenButton = $('.CSZoomCanvasHiddenText');

            if (hiddenButton.length > 0) {
                hiddenButton.focus();
            }
        }).on('contextmenu', function (e) {
            e.preventDefault();
        }).on('mouseleave', function (e) {
            if (me.IsEmpty) {
                return;
            }

            me.MouseDown = false;
            me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
            me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;

            if (Math.abs(e.clientX - me.MouseClickedPos.X) < 2 &&
                Math.abs(e.clientY - me.MouseClickedPos.Y) < 2) {
                me.CanvasContentEdge.trigger('CanvasClick', e);
            }
            me.MouseDragging = false;
        });

        CS.doc.on('mouseup.' + this.CanvasId, function (e) {

            if (me.IsEmpty) {
                return;
            }

            me.MouseDown = false;
            me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
            me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;

            if (Math.abs(e.clientX - me.MouseClickedPos.X) < 2 &&
                Math.abs(e.clientY - me.MouseClickedPos.Y) < 2) {
                me.CanvasContentEdge.trigger('CanvasClick', e);
            }
            me.MouseDragging = false;

        }).on('mousemove.' + this.CanvasId, function (e) {

            if (me.IsEmpty || me.Freeze) {
                return;
            }

            me.MouseHasNeverMove = false;

            me.MouseRealPos = new Point(e.clientX, e.clientY);
            me.MouseOnScaleCorrection = me.GetRelativeMousePos();

            if (me.MouseDown) {
                e.preventDefault();
                me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X + (me.MouseRealPos.X - me.MouseClickedPos.X) / me.Scale;
                me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y + (me.MouseRealPos.Y - me.MouseClickedPos.Y) / me.Scale;
                me.Translate();

                if (!me.MouseDragging) {
                    if (Math.abs(e.clientX - me.MouseClickedPos.X) > 2 || Math.abs(e.clientY - me.MouseClickedPos.Y) > 2) {
                        me.MouseDragging = true;
                        me.CanvasContentEdge.trigger('StartDragging', e);
                    }
                }
            }
        });
        var hiddenButton = $('.CSZoomCanvasHiddenText');

        hiddenButton.on('keydown.' + this.CanvasId, function (e) {
            console.log("Keydown " + e.which + " " + me.Scale);
            if (me.IsEmpty || me.Freeze) {
                return;
            }
            switch (e.which) {
                case 37: // left
                    me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                    me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X + 20 / me.Scale;
                    me.Translate();
                    break;

                case 38: // up
                    me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                    me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y + 20 / me.Scale;
                    me.Translate();
                    break;

                case 39: // right
                    me.CanvasLastTopLeftPos.X = me.CanvasNewTopLeftPos.X;
                    me.CanvasNewTopLeftPos.X = me.CanvasLastTopLeftPos.X - 20 / me.Scale;
                    me.Translate();
                    break;

                case 40: // down
                    me.CanvasLastTopLeftPos.Y = me.CanvasNewTopLeftPos.Y;
                    me.CanvasNewTopLeftPos.Y = me.CanvasLastTopLeftPos.Y - 20 / me.Scale;
                    me.Translate();
                    break;

                case 109: // minus
                case 189: // minus
                    me.ScaleUpDown(false);
                    break;

                case 107: // plus
                case 187: // plus
                    me.ScaleUpDown(true);
                    break;

                default: return; // exit this handler for other keys
            }
            e.preventDefault(); // prevent the default action (scroll / move caret)
        });
    }


    me.UpdateContentSizeValue();
    me.FitToContent();
};
CS.CSZoomCanvas.prototype = function () {

    var translateAlreadyCalled = false;
    function Translate(callback) {
        if (!translateAlreadyCalled) {
            var me = this;
            setTimeout(function () {
                var left = me.CanvasNewTopLeftPos.X - me.ScaleCorrectionPoint.X + "em";
                var top = me.CanvasNewTopLeftPos.Y - me.ScaleCorrectionPoint.Y + "em";
                var fontsize = me.Scale + "em";

                me.CanvasContent.css({
                    fontSize: fontsize,
                    left: left,
                    top: top
                });
 
                me.CanvasContentEdge.trigger('Moving', me);

                translateAlreadyCalled = false;

                if (IsDefined(typeof (callback))) {
                    callback.call(this);
                }
            }, 40);
        }
        translateAlreadyCalled = true;
    }
    function UpdateContentSizeValue() {
        this.CanvasSize = new Point(this.Canvas.width(), this.Canvas.height());
        this.CanvasContentEdge = $('.CanvasContentEdge', this.Canvas);
        this.ContentSize = new Point(this.CanvasContentEdge.data('canvascontentwidth'), this.CanvasContentEdge.data('canvascontentheight'));
        var position = this.Canvas.offset();
        this.CanvasStartPos = new Point(position.left, position.top);

        this.CanvasContentEdge.data('context', this);
    }
    function CalculCorrectionOfTranslation() {
        var ratio = new Point();

        ratio.X = (this.MouseRealPos.X - this.CanvasStartPos.X) / this.CanvasSize.X;
        ratio.Y = (this.MouseRealPos.Y - this.CanvasStartPos.Y) / this.CanvasSize.Y;

        var diffX = this.MouseOnScaleCorrection.X - this.MouseRealPos.X;
        var diffY = this.MouseOnScaleCorrection.Y - this.MouseRealPos.Y;

        this.ScaleCorrectionPoint.X = ((this.CanvasSize.X - this.CanvasSize.X / this.Scale) * ratio.X) + diffX;
        this.ScaleCorrectionPoint.Y = ((this.CanvasSize.Y - this.CanvasSize.Y / this.Scale) * ratio.Y) + diffY;
    }
    function GetRelativeMousePos() {
        return this.GetRelativePoint(this.MouseRealPos.X, this.MouseRealPos.Y);
    }
    function GetRelativePoint(_x, _y) {
        var x = (_x - this.CanvasStartPos.X) / this.Scale + (this.ScaleCorrectionPoint.X + this.CanvasStartPos.X);
        var y = (_y - this.CanvasStartPos.Y) / this.Scale + (this.ScaleCorrectionPoint.Y + this.CanvasStartPos.Y);
        return new Point(x, y);
    }
    function FitToContent(callback) {

        if (this.CanvasContentEdge != null && this.CanvasContentEdge.length > 0) {
            var ratioX = this.CanvasSize.X / this.ContentSize.X;
            var ratioY = this.CanvasSize.Y / this.ContentSize.Y;

            if (ratioX < ratioY) {
                this.Scale = ratioX;
            }
            else {
                this.Scale = ratioY;
            }
            var corrX = parseFloat((((this.CanvasSize.X - (this.ContentSize.X * this.Scale)) / 2) / this.Scale).toFixed(3));
            var corrY = parseFloat((((this.CanvasSize.Y - (this.ContentSize.Y * this.Scale)) / 2) / this.Scale).toFixed(3));

            this.CanvasNewTopLeftPos.X = corrX;
            this.CanvasNewTopLeftPos.Y = corrY;
            this.CanvasLastTopLeftPos.X = corrX;
            this.CanvasLastTopLeftPos.Y = corrY;
            this.ScaleCorrectionPoint.X = 0;
            this.ScaleCorrectionPoint.Y = 0;
            this.Translate(callback);
        }

    }
    function CenterElement(element, callback) {
        if (element != null && element.length > 0) {
            var eleLeft = -(this.CanvasLastTopLeftPos.X - this.ScaleCorrectionPoint.X - (element.offset().left - this.CanvasStartPos.X) / this.Scale);
            var eleTop = -(this.CanvasLastTopLeftPos.Y - this.ScaleCorrectionPoint.Y - (element.offset().top - this.CanvasStartPos.Y) / this.Scale);

            var offsetX = parseFloat(this.CanvasSize.X / 2 / this.Scale - eleLeft - (element.width() / this.Scale / 2).toFixed(3));
            var offsetY = parseFloat(this.CanvasSize.Y / 2 / this.Scale - eleTop - (element.height() / this.Scale / 2).toFixed(3));

            this.CanvasNewTopLeftPos.X = offsetX;
            this.CanvasNewTopLeftPos.Y = offsetY;
            this.CanvasLastTopLeftPos.X = offsetX;
            this.CanvasLastTopLeftPos.Y = offsetY;
            this.ScaleCorrectionPoint.X = 0;
            this.ScaleCorrectionPoint.Y = 0;

            this.Translate(callback);
        }

    }
    function ShowHideContent(hide) {
        if (hide) {
            this.CanvasContent.css('visibility', 'hidden');
        }
        else {
            this.CanvasContent.css('visibility', 'visible');
        }
    }
    function LoadNewContent(content, updateOnlyHtml, callback) {
        this.MouseDown = false;
        ClearContent.call(this);

        if (updateOnlyHtml) {
            this.CanvasContent[0].innerHTML = content;
            this.UpdateContentSizeValue();
            this.IsEmpty = false;
            if (IsDefined(typeof (callback))) {
                callback.call(this);
            }
        }
        else {
            this.LoadingContent = true;
            this.CanvasContent[0].innerHTML = content;
            this.UpdateContentSizeValue();
            this.IsEmpty = false;
            this.FitToContent(callback);
        }
    }
    function ClearContent() {
        this.CanvasContent.html('');
        this.IsEmpty = true;
        this.MouseHasNeverMove = true;
    }
    function ScaleUpDown(up, zoomButton) {
        var me = this;

        if (zoomButton) {
            me.MouseRealPos = new Point(me.CanvasSize.X / 2, me.CanvasSize.Y / 2);
            me.MouseOnScaleCorrection = me.GetRelativeMousePos();
        }

        me.Scale += up ? me.ScaleSpeed : -me.ScaleSpeed;

        if (me.Scale < 1) {
            me.Scale = 1;
        }

        me.CalculCorrectionOfTranslation();
        me.Translate();

    }
    function ScaleTo(scale, callback) {
        var me = this;

        me.Scale = scale;
        me.CalculCorrectionOfTranslation();
        me.Translate(callback);
    }

    return {
        Translate: Translate,
        CalculCorrectionOfTranslation: CalculCorrectionOfTranslation,
        GetRelativeMousePos: GetRelativeMousePos,
        FitToContent: FitToContent,
        CenterElement: CenterElement,
        GetRelativePoint: GetRelativePoint,
        UpdateContentSizeValue: UpdateContentSizeValue,
        ShowHideContent: ShowHideContent,
        LoadNewContent: LoadNewContent,
        ClearContent: ClearContent,
        ScaleUpDown: ScaleUpDown,
        ScaleTo: ScaleTo
    };

}();

function Point(x, y) {
    this.X = x;
    this.Y = y;
}
*/ 

//# sourceMappingURL=cs.zoomcanvas.js.map
